<template>
  <div class="image-preview">
      <img class="image-preview__image" :src="src" alt="">
  </div>
</template>

<script>
export default {
    name: 'ImagePreview',
    props: {
        src: String,
        default: () => ''
    }
}
</script>

<style scoped lang="scss">
.image-preview {
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    &__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>